import axios from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
var token = cookies.get('token');

export function fetchBrands () {
	return function(dispatch) {
		axios.get(window.api+'brand?token='+token)
			.then((response) => {
				dispatch({type: 'FETCH_BRANDS_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'FETCH_BRANDS_REJECTED', payload: error});
			})
	}
}

export function fetchBrandsExcel () {
	return function(dispatch) {
		axios.get(window.api+'brandsExcelMenu?token='+token)
			.then((response) => {
				dispatch({type: 'FETCH_BRANDS_MENU_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'FETCH_BRANDS_REJECTED', payload: error});
			})
	}
}

export function createBrand (de, cn) {
	return function(dispatch) {
		axios.post(window.api+'brand?token='+token, {
                de: de,
                cn: cn,
			})
			.then((response) => {
				dispatch({type: 'CREATE_BRAND_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'CREATE_BRAND_REJECTED', payload: error});
			});
			
		return Promise.resolve();
	}
}

export function clearBrand () {
	return function(dispatch) {
		// axios.get(window.api+'brand/'+id+'?token='+token)
		// 	.then((response) => {
		// 		dispatch({type: 'FETCH_BRAND_FULFILLED', payload: response.data});
		// 	})
		// 	.catch((error) => {
				dispatch({type: 'CLEAR_BRAND', payload: []});
			// });

		return Promise.resolve();
	}
}

export function fetchBrand (id) {
	return function(dispatch) {
		axios.get(window.api+'brand/'+id+'?token='+token)
			.then((response) => {
				dispatch({type: 'FETCH_BRAND_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'FETCH_BRAND_REJECTED', payload: error});
			});

		return Promise.resolve();
	}
}

export function clearBrandProducts () {
	return function(dispatch) {
		dispatch({type: 'CLEAR_BRAND_LASTYEAR_PRODUCTS', payload: []});
		// return Promise.resolve();
	}
}

export function updateBrand (id, de, cn, alias, image) {
	return function(dispatch) {
		const config = { headers: { 'Content-Type': 'multipart/form-data' } };

		var bodyFormData = new FormData();

		bodyFormData.set('de', de);
		bodyFormData.set('cn', cn);
		bodyFormData.set('alias', alias);
		bodyFormData.set('image', image);
		bodyFormData.set('_method', 'PUT');

		axios.post(window.api+'brand/'+id+'?token='+token, bodyFormData, config).then((response) => {
			dispatch({type: 'UPDATE_BRAND_FULFILLED', payload: response.data});
		})
		.catch((error) => {
			dispatch({type: 'UPDATE_BRAND_REJECTED', payload: error});
		});
			
		return Promise.resolve();
	}
}

export function deleteBrand (id) {
	return function(dispatch) {
		axios.delete(window.api+'brand/'+id+'?token='+token)
			.then((response) => {
				dispatch({type: 'DELETE_BRAND_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'DELETE_BRAND_REJECTED', payload: error});
			});

		return Promise.resolve();
	}
}

